import React from 'react';
import { Url } from '@wix/da-url';
import FolderRibbon from '../../../../../Primitives/FolderRibbon';
import FolderCoverInfo from '../../../../../FolderCoverInfo';
import GallectionCoverDumbo from '../../../../../GallectionCoverDumbo';
import shopFolderThumbStyles from '../../ShopFolderThumb.scss';
var padding = parseInt(shopFolderThumbStyles['folder-thumb-padding']);
var FolderContent = function (_a) {
    var folder = _a.folder, width = _a.width, height = _a.height, hasBlurredCoverTooltip = _a.hasBlurredCoverTooltip;
    var thumb = folder.thumb;
    var thumbWidth = width ? width - padding * 2 : undefined;
    var thumbHeight = height - padding;
    return (React.createElement("a", { className: shopFolderThumbStyles['thumb'], href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name,
        }) },
        React.createElement(GallectionCoverDumbo, { gallection: folder, width: thumbWidth, height: thumbHeight }),
        thumb && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: shopFolderThumbStyles['thumb-overlay'] }),
            React.createElement("div", { className: shopFolderThumbStyles['thumb-overlay-top'] }),
            hasBlurredCoverTooltip && (React.createElement("div", { className: shopFolderThumbStyles['top-right-icon'] },
                React.createElement(FolderCoverInfo, null))))),
        React.createElement(FolderRibbon, { premiumFolderData: folder.premiumFolderData, className: shopFolderThumbStyles['folder-badge'] })));
};
FolderContent.displayName = 'FolderContent';
export default FolderContent;
//# sourceMappingURL=FolderContent.js.map